import {default as BaseInitializer} from "parent/ts/store/Components/Blocks/Initializer";
// import Hero from "parent/src/js/base/Controllers/Blocks/Hero";
// import NewBlockControllerTemplate from "~/js/Controllers/Blocks/NewBlockControllerTemplate";

class Initializer extends BaseInitializer {

	// example on how to set up predefined blocks
	// here, we disable the content stickyness of the Hero block
	/*initBlock(block) {
		if (block instanceof Hero) {
			block.hasStickyContent = false;
		}

		return block;
	}
	*/

	// initialize your new blocks here
	// delete this method if you are not intending to register new blocks
	/*getBlocks() {
		const blocks = super.getBlocks();
		// To add a new block
		blocks[".thee-block-your-block-name"] = NewBlockControllerTemplate;

		// To delete a block
		delete blocks[".thee-block-hero"];

		return blocks;
	}*/
}

export default Initializer;
